<template>
  <q-card
    class="column items-center"
  >
    <q-card-section class="row full-width justify-between">
      <span
        class="col text-h6"
        :class="{ 'text-center': centerTitle }"
      >
        {{ title }}
      </span>
      <q-btn
        v-if="menuActions.length"
        icon="more_horiz"
      >
        <q-menu>
          <q-item
            v-for="menuAction, index in menuActions"
            :key="index"
            v-ripple
            clickable
            exact
            @click="menuAction.handler"
          >
            <q-item-section avatar>
              <q-icon :name="menuAction.icon" />
            </q-item-section>
            <q-item-section>
              {{ menuAction.name }}
            </q-item-section>
          </q-item>
        </q-menu>
      </q-btn>
    </q-card-section>
    <q-card-section
      class="col full-width q-pt-none q-pb-lg"
    >
      <time-clock
        @clock-on="event => $emit('clock-on', event)"
        @clock-off="event => $emit('clock-off', event)"
      />
    </q-card-section>
    <q-card-actions
      v-if="actions.length"
      class="row justify-center q-gutter-x-md"
    >
      <q-btn
        v-for="action, index in actions"
        :key="index"
        flat
        :label="action.label"
        :icon="action.icon"
        :color="action.color"
        @click="action.handler"
      />
    </q-card-actions>
  </q-card>
</template>

<script>
import TimeClock from 'src/modules/register/components/time-clock/TimeClock'

export default {
  name: 'TimeClockCard',
  components: {
    TimeClock
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Time Clock'
    },
    centerTitle: {
      type: Boolean,
      required: false,
      default: false
    },
    menuActions: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    actions: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  },
  emits: ['clock-on', 'clock-off']
}

</script>

<style lang="scss" scoped>
  circle {
    stroke-width: 14px;
    fill: transparent;
  }
</style>
